import { render, staticRenderFns } from "./DeveloperTools.vue?vue&type=template&id=830a82fe&"
import script from "./DeveloperTools.vue?vue&type=script&lang=js&"
export * from "./DeveloperTools.vue?vue&type=script&lang=js&"
import style0 from "./DeveloperTools.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports